import { getTZOffset } from '@mote/helpers/datetime'
import { getGodModeOptionsState } from '@mote/helpers/identity'
import { useGenericRequestHandler } from '../../handlers'
import type { Account, GenericHandlerValues } from '../../models'

export interface AccountUserSearchResponse {
  account: Account
}

export type UseAccountQueryValues = GenericHandlerValues<
  AccountUserSearchResponse,
  'POST'
>

export function useAccountQuery(
  useGodModeOptions = false
): UseAccountQueryValues {
  const godModeState = getGodModeOptionsState()
  const json = { TZOffset: getTZOffset() }

  //@ts-expect-error
  return useGenericRequestHandler({
    route: 'v1/c/account',
    method: 'POST',
    options: {
      json: Object.assign(json, useGodModeOptions ? godModeState.options : {}),
      shouldNotStoreAuthData: useGodModeOptions && godModeState.inGodMode
    }
  })
}
